



















import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialItem from '@/classes/MaterialItem';
import MaterialFormLineItem from '@/classes/MaterialFormLineItem';

@Component
export default class MaterialItemTable extends Vue {
    @Prop() public itemList!: MaterialItem[];
    @Prop({default: 'ID'}) public id!: string;

    public actionButtonDisabled(item: MaterialItem): boolean {
      return item.outOfStock || item.formQuantity === null || item.formQuantity === undefined;
    }

    get fields() {
        return [{
            key: 'listItem',
            label: 'Item',
            sortable: true
        }, {
            key: 'stock',
            label: 'Stock'
        }, {
            key: 'quantity',
            label: 'Quantity'
        }, {
            key: 'add',
            label: ''
        }];
  }

    public getItemName(id: number): string {
        const materialItem: MaterialItem | undefined = this.$store.getters['material/getMaterialItemById'](id);
        if (materialItem !== undefined && materialItem.listItem !== undefined && materialItem.quantityOfStock !== undefined) {
            return materialItem.listItem + ' (QTY ' + materialItem.quantityOfStock + ')';
        } else {
            return materialItem && materialItem.listItem ? materialItem.listItem : '';
        }
    }

    public sendUpdate(item: MaterialItem) {
      this.$emit('itemUpdate', item);
    }
}
